'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userJobPreferences = require('./user-job-preferences.html');

var _userJobPreferences2 = _interopRequireDefault(_userJobPreferences);

var _userJobPreferences3 = require('./user-job-preferences.controller');

var _userJobPreferences4 = _interopRequireDefault(_userJobPreferences3);

require('./user-job-preferences.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userJobPreferencesComponent = {
  restrict: 'E',
  bindings: {
    jobPreferences: '<',
    options: '<'
  },
  template: _userJobPreferences2.default,
  controller: _userJobPreferences4.default,
  controllerAs: 'vm'
};

exports.default = userJobPreferencesComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-job-preferences/user-job-preferences.component.js
 **/